import {
  pushArticlesBlogB2bMock,
  titreTexteMediaFranchiseHomepage1,
  titreTexteMediaFranchiseHomepage2,
  titreTexteMediaFranchiseHomepage3,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  titreTexteMediaFranchiseHomepage1(),
  titreTexteMediaFranchiseHomepage2(),
  titreTexteMediaFranchiseHomepage3(),
  pushArticlesBlogB2bMock,
];

export const franchiseHomepageMock: SlugPage = {
  ...pageBase({
    title: 'Espace Franchise - HP',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-b2b-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
